import { PaymentMethodType } from '../../invoicingSettings/enums/paymentMethodType'
import { InvoicePaymentMeanPayload } from '../types/invoicePayload/invoicePaymentMeansPayload'

export interface PaymentMethodsTrackingOptions {
  /* eslint-disable @typescript-eslint/naming-convention */
  bank_transfer_payment_enabled: boolean
  offline_payment_enabled: boolean
  paypal_payment_enabled: boolean
  /* eslint-enable @typescript-eslint/naming-convention */
}

export const getPaymentMethodsTrackingOptions = (
  paymentMeans?: InvoicePaymentMeanPayload[],
): PaymentMethodsTrackingOptions => {
  const hasPaymentMean = (paymentMethodType: PaymentMethodType) =>
    !!paymentMeans?.some(({ type }) => type === paymentMethodType)

  return {
    /* eslint-disable @typescript-eslint/naming-convention */
    bank_transfer_payment_enabled: hasPaymentMean(PaymentMethodType.IBAN),
    offline_payment_enabled: hasPaymentMean(PaymentMethodType.OTHER),
    paypal_payment_enabled: hasPaymentMean(PaymentMethodType.PAYPAL),
    /* eslint-enable @typescript-eslint/naming-convention */
  }
}
